<template>
  <div class="page-marketplace">
    <FrameHeader/>

    <div class="pb-5 bg-white">
      <div class="sp-banner">
        <img src="/static/pic/page_marketplace/banner_3.jpg">
      </div>
      <!-- <div class="sp-banner-text">
        {{lg('',{
          en: 'Where the #BSC Community Trades NFTs',
          zh: '#BSC社区专属的NFT交易市场',
        })}}
      </div> -->
    </div>

    <div class="bg-white pb-4">
      <div class="boxed d-flex align-items-center__x flex-wrap">

        <!-- <div class="mb-none" style="width: 180px">
        </div> -->

        <div class="ui-tabset ml-auto__x">
          <span 
            v-for="item of home_tabs"
            :key="item.id"
            @click="on_tab = item.id"
            :class="['tab size-big',{'on': on_tab == item.id}]"
          >
            {{lg('',item.name)}}
          </span>
        </div>

        <CpBtnSortList 
          class="pc-ml-auto"
          v-model="on_filter"
        />
      </div>
    </div>

    <div class="boxed home-main-box pb-4">

      <div v-if="0" class="home-filter">
        <div class="mt-4 pt-2">
          <filterSet :form="filter_set"/>
        </div>
      </div>

      <div v-if="list_recommendation.length > 0" class="home-card-list w-100">

        <div class="pt-5">
          <div class="list-main-prod-title d-flex align-items-center mx-auto">

            <span class="icon-mark fire mr-2"></span>

            <span class="b h5 mb-0">
              {{lg('',{
                en: 'Featured Collections',
                zh: '官方推荐',
              })}}
            </span>

          </div>
          <div>
            <div class="list-main-prod pb-4">
              <div class="item mb-4" v-for="(item,index) of list_recommendation.slice(0,4)" :key="index">
                <CpCardProd :data="item"/>
              </div>
            </div>
          </div>
        </div>
        
        <div class="">
          <div class="list-main-prod-title d-flex align-items-center mx-auto">

            <span class="icon-mark fire mr-2"></span>

            <span class="b h5 mb-0">
              {{lg('',{
                en: 'Hot Collections',
                zh: '热门NFT',
              })}}
            </span>

          </div>
          <div>
            <div class="list-main-prod pb-4">
              <div class="item mb-4" v-for="(item,index) of list_fav.slice(0,4)" :key="index">
                <CpCardProd :data="item"/>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="list-main-prod-title d-flex align-items-center mx-auto">

            <span class="icon-mark star mr-2"></span>

            <span class="b h5 mb-0">
              <span v-if="on_filter == '' || on_filter == ''">
                {{lg('',{
                  en: 'Recently Minted',
                  zh: '最新NFT',
                })}}
              </span>
              <span v-else>
                {{lg('',$store.state.fecfg.cate_sort_list.find(i => i.id == on_filter).name)}}
              </span>
            </span>

          </div>
          <div v-if="!status_ajaxing_list">
            <div class="list-main-prod pb-5">
              <div class="item mb-4" v-for="(item,index) of list_on_show" :key="index">
                <CpCardProd :data="item"/>
              </div>
            </div>

            <div class="boxed">
              <CpPagination
                :mix_class="'justify-content-center'"
                :conf="pagination_cfg"
                @reloadList="getListOnShow"
              />
            </div>
          </div>

          <div>
            <div v-if="status_ajaxing_list" class="t-gray tac py-5">
              Loading... 
            </div>
          </div>
        </div>
      </div>

    </div>

    <FrameFooter/>
  </div>
</template>

<script>
// import list_main_asset from '@/data/list_main_asset.js'
import home_tabs from './home_tabs.js'
import filterSet from './filter_set.vue'

import data_filter_set from './data_filter_set.js'

let data_filter_set_keys = data_filter_set.map(item => item.id)
let init_filter_keys = {}
data_filter_set_keys.forEach(function(item){
  init_filter_keys[item] = ''
})

export default {
  name: 'pageHome',
  components: {
    filterSet,
  },
  props: [],
  data() {
    return {
      on_tab: 'all',
      on_filter: '',
      home_tabs: home_tabs,

      status_ajaxing_list: false,
      list_on_show: [],


      filter_set: init_filter_keys,

      // scroll load
      next_page_num: 1,
      status_no_more_data: false,

      pagination_cfg: {
        'page_size': 40, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 100, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages': 100, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },

      // 写死的官方推荐4个
      cfg_recommendation: [
        {
          nft_address: '0x3E31F70912c00AEa971A8b2045bd568D738C31Dc',
          nft_id: 4679,
          owner: '0x774a2978a737456c480cf7b38ffb1f97e86ea649',
        },
        {
          nft_address: '0x3E31F70912c00AEa971A8b2045bd568D738C31Dc',
          nft_id: 4687,
          owner: '0x774a2978a737456c480cf7b38ffb1f97e86ea649',
        },
        {
          nft_address: '0x3E31F70912c00AEa971A8b2045bd568D738C31Dc',
          nft_id: 4688,
          owner: '0x774a2978a737456c480cf7b38ffb1f97e86ea649',
        },
        {
          nft_address: '0x3E31F70912c00AEa971A8b2045bd568D738C31Dc',
          nft_id: 4690,
          owner: '0x774a2978a737456c480cf7b38ffb1f97e86ea649',
        },
      ],
      list_recommendation: [],

      // 
      list_fav: [],
      status_ajaxing_list_fav: false,
    }
  },
  computed: {},
  watch: {
    on_tab(){
      this.resetGetListFrom()
      this.getListOnShow()
    },
    on_filter(){
      this.resetGetListFrom()
      this.getListOnShow()
    },
    filter_set: {
      deep: true,
      handler(){
        this.resetGetListFrom()
        this.getListOnShow()
      },
    },
  },
  methods: {

    async getListRecommendation(){
      let v = this

      v.cfg_recommendation.forEach( async (item) => {
        let res = await v.api('query_item_detail',item)

        if(res.code == 0){
          if(!res.data.owner_info){
            res.data.owner_info = {}
          }
          v.list_recommendation.push(res.data) 
        }
        
      })
      
    },

    resetGetListFrom(){
      this.pagination_cfg.page_current = 1
      
      this.next_page_num = 1
      this.status_no_more_data = false
      this.list_on_show = []
    },
    
    async getListOnShow(){
      let v = this

      // 最受喜爱 列表
      await v.api('list_asset',{
        'category': 'all',
        'filter': 'most_liked',
        'filter_more': {},
        'page_num': 1,
        'page_size': 4,
      },{
        vue: v,
        key_data: 'list_fav',
        key_ajaxing: 'status_ajaxing_list_fav',
      })


      // 主列表
      await v.api('list_asset',{
        'category':v.on_tab,
        'filter':v.on_filter,
        'filter_more':v.filter_set,
        // 'page_num': v.next_page_num,
        'page_num': v.pagination_cfg.page_current,
        'page_size': v.page_size,
      },{
        vue: v,
        key_data: 'list_on_show',
        key_ajaxing: 'status_ajaxing_list',
      })


    },
    run(){
      let v = this
      if(!v.on_tab){
        v.on_tab = v.home_tabs.length?v.home_tabs[0].id:''
      }

      v.getListOnShow()
      v.getListRecommendation()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>

  .page-marketplace{

    .sp-banner{
      // background-color: #D99230;
      background-color: #001920;
      text-align: center;
      img{
        max-width: 100vw;
        max-height: 485px;
      }
    }
    .sp-banner-text{
      background-color: #845C2F;
      color: #fff;
      max-width: 500px;
      margin: 0 auto;
      border-radius: 50px;
      padding: 5px 20px;
      font-size: 1.3em;
      text-align: center;
    }

    .home-main-box{

      @media(min-width: 788px){
        display: flex;

        .home-filter{
          width: 300px;
        }
        .home-cards-list{
          width: 100%;
        }
      }
    }
  }
</style>